import { ThemeProvider } from '@ori-ui/mui';
import type { VFC } from 'react';

import DialogWrapper from './components/DialogWrapper/DialogWrapper';
import { ErrorBoundary } from './containers/ErrorBoundary/ErrorBoundary';
import { I18nContainer } from './containers/I18nContainer/I18nContainer';
import { ConfigurationProvider } from './contexts/configurationContext';
import type { AppConfiguration } from './models/AppConfiguration';

interface AppProps {
  configuration: AppConfiguration;
}

export const App: VFC<AppProps> = ({ configuration }) => (
  <ConfigurationProvider value={configuration}>
    <ErrorBoundary>
      <I18nContainer>
        <ThemeProvider
          enableCacheProvider
          cacheKey="logout-confirm-dialog"
        >
          <DialogWrapper />
        </ThemeProvider>
      </I18nContainer>
    </ErrorBoundary>
  </ConfigurationProvider>
);
